import { mountReactComponentsOnTurboLoad } from '../helpers/ReactUJS'

mountReactComponentsOnTurboLoad()
